"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
var css_1 = require("@emotion/css");
var react_1 = __importStar(require("react"));
var TabProvider_1 = require("../TabProvider/TabProvider");
exports.TabPanel = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, value = _a.value, shouldRenderWhenHidden = _a.shouldRenderWhenHidden, testId = _a.testId, className = _a.className, other = __rest(_a, ["children", "value", "shouldRenderWhenHidden", "testId", "className"]);
    var context = (0, react_1.useContext)(TabProvider_1.TabContext);
    if (!('value' in context)) {
        console.warn('TabPanel does not support selection behavior outside of a TabProvider');
    }
    var currentValue = context.value;
    var isHidden = currentValue !== value;
    return (react_1.default.createElement("div", __assign({ role: "tabpanel", hidden: isHidden, id: "tabpanel-".concat(value), "aria-labelledby": "tab-".concat(value), "data-testid": testId, className: (0, css_1.cx)('ds-tab-panel', className, (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: ", ";\n      "], ["\n        display: ", ";\n      "])), isHidden && shouldRenderWhenHidden ? 'none' : undefined)) }, other, { ref: ref }), (!isHidden || shouldRenderWhenHidden) && children));
});
exports.TabPanel.displayName = 'TabPanel';
var templateObject_1;
